var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook Icon"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M7.99962,-4.79616213e-15 L7.99962,0.00155200388 L8.0001,0.00155200388 L8.0001,3.201544 L6.400016,3.201544 C5.84801462,3.201544 5.600014,3.84855362 5.600014,4.401555 L5.600014,6.401536 L5.600094,6.401536 L8.00002,6.401536 L8.00002,9.601544 L5.600014,9.601544 L5.600014,16.00156 L2.399614,16.00004 L2.400006,9.601544 L1.0125234e-13,9.601544 L1.0125234e-13,6.401536 L2.400006,6.401536 L2.400086,3.201544 C2.400086,1.43422759 3.83272958,0.00154400386 5.600094,0.00154400386 L7.99962,-4.79616213e-15 Z","fill":"currentcolor"}))]);
}

Facebook.defaultProps = {"viewBox":"0 0 8 16","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
